{
  "apiKey": "AIzaSyBLzeZ6csk9TgicrvpC9RKEzGefrogJMX8",
  "appId": "1:585142285137:web:5d9d3cf2ff8a9298121970",
  "authDomain": "project-tools-361810.firebaseapp.com",
  "databaseURL": "https://project-tools-361810-default-rtdb.europe-west1.firebasedatabase.app",
  "messagingSenderId": "585142285137",
  "projectId": "project-tools-361810",
  "storageBucket": "project-tools-361810.appspot.com"
}
